import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import emailjs from '@emailjs/browser';

const Contact = () => {
  const { register, handleSubmit, reset, formState: { errors } } = useForm();
  const [disabled, setDisabled] = useState(false);
  const [alertInfo, setAlertInfo] = useState({ display: false, message: '', type: '' });

  const onSubmit = async (data) => {
    const { firstname, lastname, email, message } = data;
    try {
      setDisabled(true);
      const templateParams = { firstname, lastname, email, message };
      await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams,
        process.env.REACT_APP_EMAILJS_PUBLIC_KEY
      );
      toggleAlert('Message sent successfully!', 'success');
    } catch (e) {
      console.error(e);
      toggleAlert('Something went wrong. Please try again.', 'error');
    } finally {
      setDisabled(false);
      reset();
    }
  };

  const toggleAlert = (message, type) => {
    setAlertInfo({ display: true, message, type });
    setTimeout(() => {
      setAlertInfo({ display: false, message: '', type: '' });
    }, 5000);
  };

  return (
    <section id="contact" className="py-24 px-6">
      <div className="max-w-xl mx-auto text-center">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary/10 text-primary text-sm font-medium mb-4">Get In Touch</span>
        <h2 className="text-4xl font-bold text-text mb-4">Contact Me</h2>
        <p className="text-base text-textlight mb-12">Need a brand, social media content, or a website? Let's talk about your next project.</p>
        
        {alertInfo.display && (
          <div className={`mb-6 px-5 py-3 rounded-xl text-sm font-medium ${
            alertInfo.type === 'success' 
              ? 'bg-green-50 text-green-700 border border-green-200 dark:bg-green-900/20 dark:text-green-400 dark:border-green-800' 
              : 'bg-red-50 text-red-700 border border-red-200 dark:bg-red-900/20 dark:text-red-400 dark:border-red-800'
          }`}>
            {alertInfo.message}
          </div>
        )}

        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
          <div className="flex gap-4">
            <div className="flex-1">
              <input {...register('firstname', { 
                required: { value: true, message: 'First name is required' }, 
                maxLength: { value: 30, message: '30 characters max' } 
              })}
                type="text" placeholder="First name" 
                className="w-full px-4 py-3.5 bg-accent border border-border rounded-xl text-sm text-text placeholder-textlight/60 disabled:opacity-50" 
                disabled={disabled} />
              {errors.firstname && <p className="text-red-500 text-xs mt-1 text-left">{errors.firstname.message}</p>}
            </div>
            <div className="flex-1">
              <input {...register('lastname', { 
                required: { value: true, message: 'Last name is required' }, 
                maxLength: { value: 30, message: '30 characters max' } 
              })}
                type="text" placeholder="Last name" 
                className="w-full px-4 py-3.5 bg-accent border border-border rounded-xl text-sm text-text placeholder-textlight/60 disabled:opacity-50" 
                disabled={disabled} />
              {errors.lastname && <p className="text-red-500 text-xs mt-1 text-left">{errors.lastname.message}</p>}
            </div>
          </div>
          <input {...register('email', { 
            required: 'Email is required', 
            pattern: { value: /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, message: 'Invalid email address' } 
          })}
            type="email" placeholder="Email" 
            className="w-full px-4 py-3.5 bg-accent border border-border rounded-xl text-sm text-text placeholder-textlight/60 disabled:opacity-50" 
            disabled={disabled} />
          {errors.email && <p className="text-red-500 text-xs mt-1 text-left">{errors.email.message}</p>}
          <textarea {...register('message', { required: 'Message is required' })}
            rows="4" placeholder="Your message" 
            className="w-full px-4 py-3.5 bg-accent border border-border rounded-xl text-sm text-text placeholder-textlight/60 disabled:opacity-50 resize-none" 
            disabled={disabled}></textarea>
          {errors.message && <p className="text-red-500 text-xs mt-1 text-left">{errors.message.message}</p>}
          <button 
            type="submit" 
            className="w-full py-3.5 bg-primary text-white rounded-xl text-sm font-medium transition-all duration-200 hover:opacity-90 hover:shadow-lg hover:shadow-primary/25 disabled:opacity-50"
            disabled={disabled}
          >
            Send Message
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;
